import ItemsCollection, {Item} from './ItemsCollection';

import Axios from 'axios';
import Module from './Module';
import axiosInstance from '@/helpers/axios';
import stores from '@/stores/index';
import {generateLog} from '@/helpers/functions';
import {showToaster} from "@/components/DashboardComposer/helpers";

const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class MODModuleItem extends Item implements ISeries {
  active!: boolean;
  sort!: number | null;
  title!: string;
  originalTitle!: string;
  shortDescription!: string;
  fullDescription!: string;
  image?: string | null | undefined;
  // @ts-ignore
  imageId: number | null | undefined;
  releaseYear!: number | null;
  endYear!: number | null;
  studio!: string;
  price!: string;
  rating!: string;
  adult!: boolean;
  origin!: string;
  moduleId!: number | null;

}

export class MODItemsCollection extends ItemsCollection<MODModuleItem> {
  model() {
    return MODModuleItem;
  }

  url(): string {
    return this.module.url();
  }

  getSeries() {
    return axiosInstance.get(this.url())
      .then((response) => response.data);
  }

}

export default class MODModule extends Module<MODItemsCollection> {

  routeName = 'mod';

  Collection() {
    return MODItemsCollection;
  }

  url() {
    return `/mod/${this.id}`;
  }

  urlItem() {
    return `${this.url()}/mod`;
  }

  crewurl() {
    return 'crews';
  }

  casturl() {
    return 'casts';
  }

  urlCategory() {
    return `${this.url()}/categories`;
  }

  urlItems() {
    return `${this.url()}/mod`;
  }

  updateCategory(id: any, category: ICategories) {
    return axiosInstance.put(`${this.urlCategory()}/${id}`, category)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewItem(item: any) {
    return axiosInstance.post(`mod/${this.id}/mod`, item)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getAllCategories(search: string | null = null) {
    if (cancel !== undefined) {
      cancel();
    }
    const searchString = (Boolean(search)) ? `search=${search}` : '';
    return axiosInstance.get(`${this.urlCategory()}?${searchString}`, {
      cancelToken: new CancelToken(function executor(c: any) {
        cancel = c;
      }),
    })
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getSpecificCategory(id: number) {
    return axiosInstance.get(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchData(index: number = 1, search: string | null, perpage: number | null,optionalParams: string | null) {
    if (cancel !== undefined) {
      cancel();
    }

    let url = `${this.urlItems()}?`
    if(Boolean(optionalParams)){
      url = url+'&'+optionalParams;
    }

    if (Boolean(search)) {
      return axiosInstance.get(`${url}&search=${search}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Series',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${url}&page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Series',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  getEpisodesDetails(id: number, seasonId: number, parentType: string) {
    return axiosInstance.get(`mod/${this.id}/${parentType}/${seasonId}/trailers/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getCrewDetails(id: number) {
    return axiosInstance.get(`${this.crewurl()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getCastDetails(id: number) {
    return axiosInstance.get(`${this.casturl()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCategoryToPage(series: MODModule, n: any) {
    return axiosInstance.post(`${this.urlItem()}/${series.id}/attach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}/unattached?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewSource(id: number, sources: any) {
    return axiosInstance.post(`/vod/${this.id}/movies/${id}/sources`, sources)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        if (e.response.data.responseCode == 400) {
          showToaster('warning', 'Error', e.response.data.error.message, 400);
        } else {
          showToaster('danger', 'Error', e.response.data.error.message);
        }
        generateLog(log);
      });
  }

  createNewCategory(category: ISeriesCategories) {
    return axiosInstance.post(`mod/${this.id}/categories`, category)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.urlItem()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.urlItem()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getCategoryItems(id: number, search: string) {
    return axiosInstance.get(`mod/${this.id}/categories`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  updateItem(id: number, series: ISeries) {
    return axiosInstance.put(`${this.urlItem()}/${id}`, series)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getSeriesDetails(id: number) {
    return axiosInstance.get(`mod/${this.id}/mod/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  createEpisodesItem(item: any, checkParentType: string, parentId: number) {
    return axiosInstance.post(`mod/${this.id}/${checkParentType}/${parentId}/trailers`, item)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteCategory(id: number) {
    return axiosInstance.delete(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchCrewCastData(index: number | null, search: string | null, perPage: number | 10) {
    // if (cancel !== undefined) {
    //   this.cancel();
    // }
    return axiosInstance.get(`crews-casts?search=${search}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  sortCategories(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchSeries(index: number | null, search: string | null, perpage: number | null) {

    if (search) {
      return axiosInstance.get(`series/${this.id}/series`)
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Series',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`series/${this.id}/series?page=${index}&perpage=${perpage}`)
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Series',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  autocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`series/${this.id}/categories?type=ajax`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  sortMovies(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlItem()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  addGenre(selectedCategory: any, seriesId: number) {
    return axiosInstance.post(`mod/${this.id}/mod/${seriesId}/categories/attach`, {name: selectedCategory})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  removeGenre(selectedCategory: any, seriesId: number) {
    return axiosInstance.post(`mod/${this.id}/mod/${seriesId}/categories/detach`, {name: selectedCategory})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteSeries(seriesId: number) {
    return axiosInstance.delete(`series/${this.id}/series/${seriesId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }
  deleteEpisode(seriesId: number, episdoeId: number) {
    return axiosInstance.delete(`series/${this.id}/series/${seriesId}/episodes/${episdoeId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteSource(episodeId: number, sourceID: number) {
    return axiosInstance.delete(`series/${this.id}/episodes/${episodeId}/sources/${sourceID}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  editExistingSource(episodeId: number, source: any) {
    return axiosInstance.put(`${this.url()}/trailers/${episodeId}/sources/${source.id}`, source)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCrew(selectedCrew: any, seriesId: number) {
    // @ts-ignore
    return axiosInstance.post(`series/${this.id}/series/${seriesId}/crews/detach`, {id: selectedCrew})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCast(selectedCast: any, seriesId: number) {
    // @ts-ignore
    return axiosInstance.post(`series/${this.id}/series/${seriesId}/casts/detach`, {id: selectedCast})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  detachTrailer(parentType: string, seriesId: number | null, episodeId: number) {
    // @ts-ignore
    return axiosInstance.delete(`/mod/${this.id}/${parentType}/${seriesId}/trailers/${episodeId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }
  attachCast(idList: number[], seriesId: number) {
    return axiosInstance.post(`mod/${this.id}/mod/${seriesId}/casts/attach`, {ids: idList})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCrew(idList: number[], seriesId: number) {
    return axiosInstance.post(`mod/${this.id}/mod/${seriesId}/crews/attach`, {ids: idList})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getCatalogueCategories() {
    return axiosInstance.get(this.urlCategory())
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  getSubItems(id: number, search: string) {
    return axiosInstance.get(`${this.urlCategory()}/${id}/content?search=${search}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  saveCrewItems(crew: ICrew) {
    return axiosInstance.put(`crews/${crew.id}`, crew)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  saveCastItems(cast: ICast) {
    return axiosInstance.put(`casts/${cast.id}`, cast)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  import(data: any, tableName: string, id: any) {
    return axiosInstance.post(`import/${tableName}?type=module&module_id=${id}`, {data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  export(tableName: string, id: any) {
    return axiosInstance.get(`export/${tableName}?type=module&module_id=${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  updateCrew(moduleId: number, seriesId: number, crewId: number, data: any) {
    return axiosInstance.put(`series/${this.id}/series/${seriesId}/crews/${crewId}`, {role: data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }

  updateCast(moduleId: number, seriesId: number, castId: number, data: any) {
    return axiosInstance.put(`series/${this.id}/series/${seriesId}/casts/${castId}`, {role: data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Series',
          message: e,
        };
        generateLog(log);
      });
  }
}
